import { Injectable, Injector } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { OrchestrationGitService } from './orchestration-git.service';

@Injectable({ providedIn: 'root' })
export class OrchestrationGitFactoryService extends AbstractGitFactoryService<OrchestrationGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: OrchestrationGitService,
    });
  }
}
